import { render, staticRenderFns } from "./ListCompliance.html?vue&type=template&id=d914f32c&scoped=true&external"
import script from "./ListCompliance.vue?vue&type=script&lang=js"
export * from "./ListCompliance.vue?vue&type=script&lang=js"
import style0 from "./ListCompliance.scss?vue&type=style&index=0&id=d914f32c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d914f32c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
